
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'date-range',
        field: 'created_at',
        label: 'Data de Cadstro',
        clearable:true,
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/log/email/_form/filters.js